document.addEventListener("DOMContentLoaded", function () {
  const codeBlocks = document.querySelectorAll('pre code');
  if (codeBlocks.length > 0 && typeof hljs !== 'undefined') {
    codeBlocks.forEach(block => {
      hljs.highlightElement(block);
    });
  }

  const shareButtons = document.querySelectorAll('.w-10.h-10');
  if (shareButtons) {
    shareButtons.forEach(button => {
      button.addEventListener('mouseenter', function() {
        this.classList.add('scale-110');
      });
      
      button.addEventListener('mouseleave', function() {
        this.classList.remove('scale-110');
      });
    });
  }

  const tocLinks = document.querySelectorAll('.toc a');
  if (tocLinks.length > 0) {
    tocLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 100,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  const replyLinks = document.querySelectorAll('.comment-reply-link');
  if (replyLinks.length > 0) {
    replyLinks.forEach(link => {
      link.addEventListener('click', function() {
        setTimeout(() => {
          const respondElement = document.getElementById('respond');
          if (respondElement) {
            respondElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      });
    });
  }

  const cancelReplyLink = document.querySelector('.comment-reply-title small a');
  if (cancelReplyLink) {
    cancelReplyLink.classList.add('text-gray-500', 'hover:text-primary', 'transition-colors', 'duration-200');
  }
});